import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'via-help-resources-layout',
  templateUrl: './help-resources-layout.component.html',
  styleUrls: ['./help-resources-layout.component.scss']
})
export class HelpResourcesLayoutComponent implements OnInit {
  public ngOnInit(): void {
    document.getElementById('top')?.scrollIntoView();
  }
}
